import http from './http'

class Documents {
  sendPayerDocs (payload) {
    return http.post('/payers/upload_docs', payload)
  }

  sendAssignorDocs (payload) {
    return http.post('/manage_documents/new_document', payload)
  }

  changeStatus (payload) {
    return http.put('/manage_documents/change_status', payload)
  }

  update (payload) {
    return http.put('/manage_documents/update', payload)
  }
}

export default new Documents()



// WEBPACK FOOTER //
// ./src/services/documents.js